import { Landing } from ".";

export default {
  path: "",
  childRoutes: [{ path: "index", component: Landing, isIndex: true }],
};
